<template>
  <li
    class="list-group-item border-success border rounded mb-3"
    :class="{'border-warning': question.status === 'P'}"
  >
    <div class="d-flex align-items-start mb-1">
      <img class="avatar mr-2" src="default-avatar.png" />
      <h5 class="word-wrap">{{question.question}}</h5>
    </div>
    <div class="d-flex justify-content-between">
      <i>{{createdAt}}</i>
      <span
        class="badge badge-pill badge-success"
        :class="{'badge-warning': question.status === 'P'}"
      >{{question.statusStr}}</span>
    </div>
    <template v-if="question.status === 'A'">
      <hr />
      <div class="d-flex align-items-start">
        <img class="avatar mr-2" src="logo192.png" />
        <h6 class="word-wrap">{{question.answer}}</h6>
      </div>
      <i>{{answeredAt}}</i>
    </template>
  </li>
</template>

<script>
import * as moment from "moment";
moment.locale("es");
export default {
  props: ["question"],
  computed: {
    createdAt() {
      return moment(this.question.createdAt).fromNow();
    },
    answeredAt() {
      return moment(this.question.answeredAt).fromNow();
    }
  }
};
</script>

<style scoped>
.badge {
  line-height: inherit !important;
}

.word-wrap {
  word-break: break-word;
  white-space: pre-line;
}

.avatar {
  vertical-align: middle;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
</style>